import { Bar, BarChart, CartesianGrid, Tooltip, XAxis } from "recharts";

import Card from "react-bootstrap/Card";
import PropTypes from "prop-types";
import React from "react";
import Spinner from "./Spinner";
import styles from "../styles/ManaCurvePanel.module.scss";
import useDarkMode from "use-dark-mode";

const ManaCurvePanel = ({ curve, isLoading }) => {
  const darkMode = useDarkMode(false);

  if (!isLoading && !curve) {
    return null;
  }

  return (
    <>
      <h5 className="title">Average Mana Curve</h5>
      <Card className="shadow-sm">
        <Card.Body className={styles.body}>
          {isLoading ? (
            <Spinner className="fa-2x" />
          ) : (
            <BarChart
              width={320}
              height={200}
              data={Object.keys(curve).map(k => ({ count: curve[k], name: k }))}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{ fill: darkMode.value ? "#eaedf0" : "#22262a" }} />
              <Tooltip
                contentStyle={{ background: darkMode.value ? "#000" : "#fff" }}
                cursor={{ fill: darkMode.value ? "#333" : "#ccc" }}
              />
              <Bar dataKey="count" fill="#007bff" />
            </BarChart>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

ManaCurvePanel.propTypes = {
  curve: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
};

export default ManaCurvePanel;
